module.exports = __webpack_public_path__ + "img/gp-bily.c6125ff7.png";